exports.components = {
  "component---node-modules-nca-acquiring-theme-src-pages-404-js": () => import("./../../../node_modules/nca-acquiring-theme/src/pages/404.js" /* webpackChunkName: "component---node-modules-nca-acquiring-theme-src-pages-404-js" */),
  "component---node-modules-nca-acquiring-theme-src-templates-main-template-js": () => import("./../../../node_modules/nca-acquiring-theme/src/templates/MainTemplate.js" /* webpackChunkName: "component---node-modules-nca-acquiring-theme-src-templates-main-template-js" */)
}

